import { Action } from "@ngrx/store";
import { IDashboardItemEvaluation } from "../../models/types";

export const RESET_STATE = "[evaluation] ResetState";
export const ADD = "[evaluation] Add";
export const REPLACE = "[evaluation] Replace";
export const UPDATE = "[evaluation] Update";
export const DELETE = "[evaluation] Delete";

/**
 * Every action is comprised of at least a type and an optional
 * payload. Expressing actions as classes enables powerful
 * type checking in reducer functions.
 *
 * See Discriminated Unions: https://www.typescriptlang.org/docs/handbook/advanced-types.html#discriminated-unions
 */
export class ResetStateAction implements Action {
  readonly type = RESET_STATE;
  constructor(public payload?: IDashboardItemEvaluation) {}
}

export class AddAction implements Action {
  readonly type = ADD;
  constructor(public payload: IDashboardItemEvaluation) {}
}

export class ReplaceAction implements Action {
  readonly type = REPLACE;
  constructor(public payload: IDashboardItemEvaluation) {}
}

export class UpdateAction implements Action {
  readonly type = UPDATE;
  constructor(public payload: IDashboardItemEvaluation) {}
}

export class DeleteAction implements Action {
  readonly type = DELETE;
  constructor(public payload: { id: string }) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
  | ResetStateAction
  | AddAction
  | ReplaceAction
  | UpdateAction
  | DeleteAction;



// WEBPACK FOOTER //
// ./src/app/store/actions/evaluation.actions.ts